export const LasersShooting = (props) => {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  style={{
                        margin: "auto",
                        display: "block",
                        zIndex: 1,
                        position: "absolute",
                  }}
                  width={"100vw"}
                  height={"100svh"}
                  preserveAspectRatio="xMidYMid"
                  viewBox="0 0 1536 750"
            >
                  <g transform="translate(768,375) scale(1,1) translate(-768,-375)">
                        <style type="text/css">
                              {
                                    "\n@keyframes ld-speed-dash {\n0% { transform: translate(0,-2031.8861830323667px); }\n100% { transform: translate(0,2031.8861830323667px); }\n}\n.ld.ld-speed-dash {\nanimation: ld-speed-dash 100s linear infinite;\n}\n"
                              }
                        </style>
                        <g transform="translate(768,375)">
                              <g
                                    style={{
                                          transform: "rotate(45deg)",
                                    }}
                              >
                                    <line
                                          x1={135.03260178814025}
                                          x2={135.03260178814025}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.1474156702843796}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-34.06792529523717s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={229.00508560226638}
                                          x2={229.00508560226638}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={2.800481893008805}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-36.68246861941595s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-614.6791741379856}
                                          x2={-614.6791741379856}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.0170305666207915}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-54.15596076433338s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-295.6790294968006}
                                          x2={-295.6790294968006}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.9811337656740371}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-75.85487036369483s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={379.9321877370245}
                                          x2={379.9321877370245}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={2.5782818980901547}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-42.07766235407564s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-631.1849785526517}
                                          x2={-631.1849785526517}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={3.130840538873919}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-35.350338845363915s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={505.95485833145005}
                                          x2={505.95485833145005}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.0186657847673186}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-53.437679825118266s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={669.5142978521621}
                                          x2={669.5142978521621}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={3.9368399159801335}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-18.930688457716727s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-177.75236236000387}
                                          x2={-177.75236236000387}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={2.373139132376776}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-35.693730409815075s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={92.85879414854696}
                                          x2={92.85879414854696}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.004787191025882}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-97.54032835006201s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={4.12277339559148}
                                          x2={4.12277339559148}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.7925247317888684}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-29.80397787675564s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={732.4740107950383}
                                          x2={732.4740107950383}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.3191291003393624}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-51.6131663467418s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={524.9660193628742}
                                          x2={524.9660193628742}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.279951374417395}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-19.942143656607534s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-111.38749429656116}
                                          x2={-111.38749429656116}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={3.082938992743877}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-50.25508454325538s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-96.69016922562378}
                                          x2={-96.69016922562378}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.5720664017951458}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-80.65317833619743s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={565.608418581302}
                                          x2={565.608418581302}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.799680977968909}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-72.22088913970452s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={714.5519440733359}
                                          x2={714.5519440733359}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.952666522807137}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-31.971987406430568s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-631.8162655901236}
                                          x2={-631.8162655901236}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={3.4860666971760637}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-4.9134906471896s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={700.3775099630037}
                                          x2={700.3775099630037}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.1396973321136565}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-25.507347393998426s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-175.6645301306961}
                                          x2={-175.6645301306961}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.361849510259943}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-18.623285490746234s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-679.1326146873497}
                                          x2={-679.1326146873497}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.8258524686402546}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-82.79799393209201s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={268.4042872714168}
                                          x2={268.4042872714168}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.782973436553613}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-76.66815851202739s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-103.45521112778772}
                                          x2={-103.45521112778772}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.842190763911567}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-62.445278487126686s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-404.1613432458116}
                                          x2={-404.1613432458116}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.2631691188959806}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-35.65170758882139s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={84.69997644492616}
                                          x2={84.69997644492616}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.5543248645122265}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-86.50828804492187s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={225.69524957621059}
                                          x2={225.69524957621059}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={3.0088447797209197}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-75.03247777704334s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={696.7535414304302}
                                          x2={696.7535414304302}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.106412469382351}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-97.0672445773002s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={142.8193081343128}
                                          x2={142.8193081343128}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.0891820981278222}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-14.436671926289945s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-185.44091402023844}
                                          x2={-185.44091402023844}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.8567504388392366}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-54.77083475087932s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-509.0315629889142}
                                          x2={-509.0315629889142}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.376746814294975}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-34.16535859144625s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={186.68856209680825}
                                          x2={186.68856209680825}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.110591631541603}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-63.513099530942995s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-64.29108077637022}
                                          x2={-64.29108077637022}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.45611156840667855}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-54.20451016487733s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={317.4598147270144}
                                          x2={317.4598147270144}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={3.0160299295240356}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-52.400892549434985s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={80.37217769637516}
                                          x2={80.37217769637516}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.487627750563147}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-75.59870159606491s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={9.84639044312405}
                                          x2={9.84639044312405}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.33966667688436813}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-9.266174283185102s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={24.270819460427333}
                                          x2={24.270819460427333}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.14579747522379338}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-62.11550976116477s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={250.81083247187394}
                                          x2={250.81083247187394}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.399050052115891}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-68.46733058618875s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-57.860932115161745}
                                          x2={-57.860932115161745}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.241341511405762}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-25.696248324798486s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-652.1608991334349}
                                          x2={-652.1608991334349}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.4332341579107943}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-66.07849321502741s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-371.5482746542209}
                                          x2={-371.5482746542209}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={3.520906578349842}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-79.91660618663836s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={358.03073504653594}
                                          x2={358.03073504653594}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={3.134653894163011}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-73.7998320482077s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-115.34116351448017}
                                          x2={-115.34116351448017}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.5739697658950615}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-99.77536631193288s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={734.5852205791185}
                                          x2={734.5852205791185}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.572748832590958}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-94.81521070111505s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={259.6162562099788}
                                          x2={259.6162562099788}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={3.1322814626405213}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-42.07656210950266s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-488.12804683580896}
                                          x2={-488.12804683580896}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.4320237220613643}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-93.86784873831975s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={517.9645795468844}
                                          x2={517.9645795468844}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.20786470107998722}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-95.2124204940388s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={439.640366892952}
                                          x2={439.640366892952}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.835228741890459}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-86.02094526440553s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={150.65644793553872}
                                          x2={150.65644793553872}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.5519986120003118}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-73.3756262153144s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-41.30008847090096}
                                          x2={-41.30008847090096}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.161064148294528}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-47.32909138321586s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-363.1698287287811}
                                          x2={-363.1698287287811}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={2.999754416505186}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-93.77326082323648s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-365.98698805544495}
                                          x2={-365.98698805544495}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.125640055398973}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-72.68043543690874s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-491.9249337693939}
                                          x2={-491.9249337693939}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={3.730256708724391}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-8.334593096764964s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={514.4008244086199}
                                          x2={514.4008244086199}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.654206731752019}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-99.30259663831812s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={278.7629860805986}
                                          x2={278.7629860805986}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.5367640346387805}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-1.213488088930581s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={732.9773551962851}
                                          x2={732.9773551962851}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={2.550476400558007}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-62.58736697612468s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-729.0428965814855}
                                          x2={-729.0428965814855}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.41670543257754}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-82.31248780165363s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={86.23421619795863}
                                          x2={86.23421619795863}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.5079339897062429}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-82.12196529408403s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={370.96236749572097}
                                          x2={370.96236749572097}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.2111661109348115}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-31.147928424775163s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={538.755396741584}
                                          x2={538.755396741584}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={3.919771804290936}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-17.65904526854609s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-564.2106459299157}
                                          x2={-564.2106459299157}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.9966171636057164}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-92.66884553096574s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={461.34278007021896}
                                          x2={461.34278007021896}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.817644578182749}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-54.99237415721099s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-226.33679279245757}
                                          x2={-226.33679279245757}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.8089055678372579}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-18.35260600222317s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={232.19878904904817}
                                          x2={232.19878904904817}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={2.854875137448901}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-17.846780443255362s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-191.83716552082035}
                                          x2={-191.83716552082035}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.9391038892606605}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-77.92332366195531s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={126.52589867745974}
                                          x2={126.52589867745974}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={3.0274862591989904}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-50.1677699874993s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-601.4735597672142}
                                          x2={-601.4735597672142}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.2556220919075578}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-54.663981403667016s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={160.17426907868958}
                                          x2={160.17426907868958}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.5518770318497999}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-70.32668073999697s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={230.53686664220925}
                                          x2={230.53686664220925}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.5384190958020028}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-9.389840616723676s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={489.2213998484341}
                                          x2={489.2213998484341}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.6267921007565167}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-63.364125442321s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-724.4032402883695}
                                          x2={-724.4032402883695}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.054459545281330124}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-13.404425235798566s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={556.9107651794}
                                          x2={556.9107651794}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.3439684768853635}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-70.11033097049742s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-423.5741436514603}
                                          x2={-423.5741436514603}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={2.5051213061572275}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-69.39815795956613s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-226.96824848099448}
                                          x2={-226.96824848099448}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={4.583557228110663}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-88.44216478869733s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-157.42250207090024}
                                          x2={-157.42250207090024}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.017556871572996}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-87.6889826570512s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={504.7916977222534}
                                          x2={504.7916977222534}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={2.2662405351707116}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-63.66403431955057s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-163.21337567351566}
                                          x2={-163.21337567351566}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.4319292745798653}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-36.92899396857021s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={527.3658120182862}
                                          x2={527.3658120182862}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.652829650817145}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-47.131213069706114s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-411.14514341735287}
                                          x2={-411.14514341735287}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.7409131036018022}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-17.014873388590356s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-668.175520569653}
                                          x2={-668.175520569653}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.958781172724619}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-41.86458224248s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={678.5965429434382}
                                          x2={678.5965429434382}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={4.452678315335735}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-2.7767258527614525s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={243.39966838600935}
                                          x2={243.39966838600935}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.5051064694760752}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-23.634852154611007s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={377.34740647441276}
                                          x2={377.34740647441276}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.010908423561575287}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-28.00082501907324s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-488.5119822220702}
                                          x2={-488.5119822220702}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.0004162735820756325}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-89.53250081555561s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-185.40881772553473}
                                          x2={-185.40881772553473}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.5806529436773677}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-36.43490285760274s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-569.3703712372048}
                                          x2={-569.3703712372048}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.833356570071675}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-13.461334970114146s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-654.6222020252044}
                                          x2={-654.6222020252044}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={2.3901464507410033}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-36.37611078444518s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={211.86785806012585}
                                          x2={211.86785806012585}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.5342370747518421}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-62.195935764795784s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-652.4293543731233}
                                          x2={-652.4293543731233}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.026474971059978758}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-23.26865231995825s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={666.8517554315816}
                                          x2={666.8517554315816}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={3.7013280136533746}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-35.131321286239015s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={62.82014104834752}
                                          x2={62.82014104834752}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={2.202738667046563}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-55.90636252877867s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={626.3965721390408}
                                          x2={626.3965721390408}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={0.432040661377171}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-70.48708269216928s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={763.8933307521971}
                                          x2={763.8933307521971}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={0.9491590876282008}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-43.4792926157596s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-661.8527581231735}
                                          x2={-661.8527581231735}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.5440061293285412}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-50.53368583639421s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={67.94160757038821}
                                          x2={67.94160757038821}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={3.140117530605929}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-44.595383812871226s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={205.88617421939819}
                                          x2={205.88617421939819}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={2.7450304033102038}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-24.277875378378333s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-212.21068423502072}
                                          x2={-212.21068423502072}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.044261705849986}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-1.2331844075100573s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={448.3166719903289}
                                          x2={448.3166719903289}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.2890093639339262}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-21.134208801086938s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-161.91231128719176}
                                          x2={-161.91231128719176}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.165946124590077}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-76.01884066810507s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={-577.1974971074434}
                                          x2={-577.1974971074434}
                                          y1={0}
                                          y2={-50}
                                          stroke="#ffffff"
                                          strokeWidth={1.8355171029049544}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-97.65306676488592s",
                                                animationDuration: "100s",
                                          }}
                                    />
                                    <line
                                          x1={445.3008277090953}
                                          x2={445.3008277090953}
                                          y1={0}
                                          y2={-50}
                                          stroke="white"
                                          strokeWidth={1.4788412732554446}
                                          strokeLinecap="round"
                                          className="ld ld-speed-dash"
                                          style={{
                                                animationDelay:
                                                      "-62.30515836875219s",
                                                animationDuration: "100s",
                                          }}
                                    />
                              </g>
                        </g>
                  </g>
            </svg>
      );
};
